import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
jQuery(document).ready(function ($) {
  function copyBillingToShipping() {
    var fields = ['first_name', 'last_name', 'company', 'address_1', 'address_2', 'city', 'postcode', 'country', 'state', 'phone'];
    if ($.inArray($('#billing_country').val(), ['CH', 'LI']) === -1) {
      alert(document.documentElement.lang !== 'fr-FR' ? "Achtung! Es kann nur in die Schweiz und Liechtenstein geliefert werden!" : "Attention ! Seuls la Suisse et le Liechtenstein peuvent être livrés. !");
    } else {
      fields.forEach(function (field) {
        var billingVal = $('#billing_' + field).val();
        var $shippingField = $('#shipping_' + field);
        if ($shippingField.length && billingVal !== undefined) {
          $shippingField.val(billingVal).trigger('change');
        }
      });
    }
  }
  jQuery("#copy-address").on('click', function () {
    copyBillingToShipping();
  });
  jQuery('[id^="shipping_"]').on('input', function () {
    var $kachel = jQuery('.address-card.active');
    var $select = jQuery('.shipping-address-select');
    if ($kachel.length) $kachel.removeClass('active');
    if ($select.length) $select.val('');
  });
  var fields = ['first_name', 'last_name', 'company', 'address_1', 'address_2', 'city', 'postcode', 'country'];
  function applyAddress(source) {
    fields.forEach(function (field) {
      var value = source.data(field);
      var $field = $('#shipping_' + field);
      if ($field.length && value !== undefined) {
        $field.val(value).trigger('change');
      }
    });
    $('html, body').animate({
      scrollTop: $('#shipping_first_name').offset().top - 100
    }, 400);
  }

  //Adresskacheln
  $('.address-card').on('click', function () {
    $('.address-card').removeClass('active');
    $(this).addClass('active');
    applyAddress($(this));
  });

  // Dropdown
  $('.shipping-address-select').on('change', function () {
    var option = $(this).find(':selected');
    if (!option.data('address_1')) return;
    applyAddress(option);
  });
});